module.exports = __webpack_public_path__ + "media/mypage/images/special/TIMES2021-159c78546f0704bd00fceb9d10c44266.jpg";